// 🔧 promotion_platforms.js
// ✅ Purpose: Defines supported social media platforms for the LGV Promotion Engine
// ✅ Features:
// - Centralized platform definitions
// - Facebook, Instagram, LinkedIn, and TikTok are available in Promotion Studio
// - Provides display labels and publishing provider identifiers
// - Exports platform keys used by post type rules
// - Fully block-commented for clarity and future devs

export const PROMOTION_PLATFORM_OPTIONS = [
  {
    value: "facebook",
    label: "Facebook",
    publishProvider: "facebook",
    enabled: true,
  },
  {
    value: "instagram",
    label: "Instagram",
    publishProvider: "instagram",
    enabled: true,
  },
  {
    value: "linkedin",
    label: "LinkedIn",
    publishProvider: "linkedin",
    enabled: true,
  },
  {
    value: "tiktok",
    label: "TikTok",
    publishProvider: "tiktok",
    enabled: true,
  },
];

export const PROMOTION_ENABLED_PLATFORM_OPTIONS =
  PROMOTION_PLATFORM_OPTIONS.filter(
    (platform) => platform.enabled
  );

export const PROMOTION_PLATFORM_KEYS =
  PROMOTION_PLATFORM_OPTIONS.reduce(
    (keys, platform) => ({
      ...keys,
      [String(platform.value || "").toUpperCase()]: platform.value,
    }),
    {}
  );
